/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * GetPromotionCodeIdByCodeResponseBase
 * auto generated base class for the model GetPromotionCodeIdByCodeResponseModel.
 */
export const GetPromotionCodeIdByCodeResponseModelBase = ModelBase.named('GetPromotionCodeIdByCodeResponse')
  .props({
    __typename: types.optional(types.literal('GetPromotionCodeIdByCodeResponse'), 'GetPromotionCodeIdByCodeResponse'),
    amountOff: types.union(types.undefined, types.null, types.number),
    id: types.union(types.undefined, types.string),
    percentOff: types.union(types.undefined, types.null, types.number)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class GetPromotionCodeIdByCodeResponseModelSelector extends QueryBuilder {
  get amountOff() {
    return this.__attr('amountOff')
  }
  get id() {
    return this.__attr('id')
  }
  get percentOff() {
    return this.__attr('percentOff')
  }
}
export function selectFromGetPromotionCodeIdByCodeResponse() {
  return new GetPromotionCodeIdByCodeResponseModelSelector()
}

export const getPromotionCodeIdByCodeResponseModelPrimitives =
  selectFromGetPromotionCodeIdByCodeResponse().amountOff.percentOff
